import { Typography, Container, Grid, Stack } from '@mui/material';
import React from 'react';
import { StyledPaperItem } from '../../common/mui-components';

export const LeagueHowToJoin = () => {
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item sm={12} md={12}>
          <Typography variant="h5led" textAlign={'center'} letterSpacing={5}>
            HOW TO JOIN
          </Typography>
        </Grid>
        <Grid item sm={12} md={12}>
          <StyledPaperItem>
            <Stack spacing={2}>
              <Typography>
                The Pilot Season was announced in the Discord
              </Typography>
              <Typography>
                We're still working on the plans for Season One. Keep an eye on
                our Discord and the Home page for updates. We'll announce it
                there once it's ready.
              </Typography>
            </Stack>
          </StyledPaperItem>
        </Grid>
      </Grid>
    </Container>
  );
};
